/******************************************************
 *    Directive parent permettant la communication entre les directives leaflet okina.
 ********************************************************/


angular.module("app").directive("okinaLeafletControlsParent", function () {

	function okinaLeafletControlsParentController(scope) {

		const COLLAPSE_STATE = {
			COLLAPSED: "COLLAPSED",
			EXPANDED: "EXPANDED"
		};

		scope.activeControl = undefined;

		// Liste de fonctions pouvant être invoquées via 'invokeFunction'
		var childFunctions = {};

		/**
         *
         * @param controlName
         */
		function setActiveControl(controlName) {
			scope.activeControl = controlName;
		}

		/**
         * Utilisé par les directives filles pour savoir si elles doivent être pliées ou dépliées.
         * @param controlName
         * @returns {boolean}
         */
		function isCollapsed(controlName) {
			return scope.activeControl !== undefined && controlName !== scope.activeControl;
		}

		/**
		 * Permet aux directives filles de s'enregistrer pour gérer le plié / déplié entre les directives
		 *
		 * @param scope
		 * @param directiveName
		 * @param collapseState		 > définie l'état d'ouverture/fermeture de la directive ajoutée, par défaut EXPANDED
		 */
		this.registerDirectiveForCollapseHandling = function (scope, directiveName, collapseState) {
			if (!collapseState) { // default value
				collapseState = COLLAPSE_STATE.EXPANDED;
			}
			if (collapseState === COLLAPSE_STATE.EXPANDED) {
				setActiveControl(directiveName);
			}
			scope.isCollapsed = isCollapsed;
			scope.toggleCollapse = function () {
				setActiveControl(isCollapsed(directiveName) ? directiveName : "not-me");
			};
		};

		/**
         * Permet aux directives filles d'enregistrer des fonctions pourvant être invoquées d'une directive à l'autre.
         * @param functionName Clé
         * @param func La fonction à invoquer.
         */
		this.registerFunction = function (functionName, func) {
			childFunctions[functionName] = func;
		};

		/**
         * Permet aux directives filles d'invoquer une fonction préalablement enregistrée.
         * @param functionName le nom de la fonction à inviquer.
         */
		this.invokeFunction = function (functionName) {
			if (childFunctions[functionName]) {
				childFunctions[functionName]();
			}
		};
	}


	return {
		restrict: "E",
		controller: ["$scope", okinaLeafletControlsParentController],
		scope: {}
	};
});
